import { GridBreakpoint } from './types';
export { DEFAULT_BREAKPOINTS } from './constants';

export const adjustBreakpointHeight = (
  breakpoints: GridBreakpoint[],
  heightDelta: number
): GridBreakpoint[] =>
  breakpoints.map(point => ({
    ...point,
    elementHeight: point.elementHeight ?? 0 + heightDelta,
  }));

export const createGridBreakpoint = ({
  screenWidth: maxWidth,
  containerWidth,
  elementSpacing,
  elementHeight,
  elementsPerRow,
}): GridBreakpoint => ({
  maxWidth,
  elementWidth:
    (containerWidth + elementSpacing) / (elementsPerRow + elementSpacing) -
    elementSpacing,
  elementHeight,
});
